// @ts-nocheck
/* eslint-disable */
export const rightIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="#00875A" d="M8 1.333C4.326 1.333 1.333 4.327 1.333 8S4.326 14.667 8 14.667 14.666 11.673 14.666 8 11.673 1.333 8 1.333m3.186 5.134-3.78 3.78a.5.5 0 0 1-.706 0L4.813 8.36a.503.503 0 0 1 0-.707.503.503 0 0 1 .707 0l1.533 1.534L10.48 5.76a.503.503 0 0 1 .706 0 .503.503 0 0 1 0 .707"/></svg>`,
    name: 'right' as const
};